import { cloneDeep } from 'lodash/lang'
import { selectDays } from 'lib/cart/services/selection'

/**
Sets days in the shopping cart for the given camper and session.
Upgrades day pass products to memberships if needed.
**/
const setCartDays = (state, action) => {
  const { camper, session, camperSession, days } = action

  // clone cart products so we don't mutate state
  const cartForm = cloneDeep(state)

  // set selected days, optionally upgrading/downgrading unlimited product
  selectDays(days, {
    camper,
    session,
    camperSession,
    cartForm
  })

  // return a new state object
  return cartForm
}

export default setCartDays
